import productSuggestion from './product-suggestion';

const MAX_SUGGESTIONS = window.SitePreferences.SEARCH_SUGGESTION_COUNT || 5;

/**
 * @param {Object} args - arguments
 * @param {Array<Object>} args.products - product data to print
 * @param {Array<Object>} args.terms - search terms data to print
 * @param {string} args.searchURL - search results URL
 * @returns {string} search suggestions HTML
 */
export default ({products, terms, searchURL}) => {
    const productsToDisplay = [];
    for (let i = 0, len = products.length; i < len; i++) {
        if (i === MAX_SUGGESTIONS) {
            break;
        }
        productsToDisplay.push(products[i]);
    }
    return `
        <div class="search-suggestion-wrapper wrapper-with-terms ${
            products.length > 0 ? 'full' : ''
        }" data-cnstrc-autosuggest>
            ${
                terms && terms.length
                    ? `
                <div class="terms-suggestions-wrapper">
                    <h2 class="terms-suggestions-header">${window.Resources.CONSTRUCTOR_SUGGESTIONS_TERMS_TITLE}</h2>
                    <ul class="terms-suggestions-list">
                        ${terms
                            .map(
                                term =>
                                    `<a 
                                    data-cnstrc-item-section="Search Suggestions" 
                                    data-cnstrc-item-name="${term.value}" 
                                    href="${term.url}"
                                >${term.value}</a>`
                            )
                            .join('')}
                    </ul>
                    <div class="hide-on-tablet hide-on-desktop close-search" role="button" tabindex="1"
                        data-open-label="${window.Resources.OPEN_SEARCH_BAR}"
                        data-close-label="${window.Resources.CLOSE_SEARCH_BAR}"
                        aria-label="${window.Resources.OPEN_SEARCH_BAR}">
                        <i class="icon icon-icon-menu-close" aria-hidden="true" tabindex="1"></i>
                    </div>
                </div>
                `
                    : ``
            }
            <div class="product-suggestions-wrapper">
                <div class="menu-flyout-general-header hide-on-mobile hide-on-tablet">
                    <h2 class="flyout-title">
                        ${window.Resources.CONSTRUCTOR_SUGGESTIONS_PRODUCTS_TITLE}
                    </h2>
                    ${
                        !window.SitePreferences.SHOW_NEW_HEADER
                            ? `<button class="search-reset">${window.Resources.CLEAR_SEARCH}</button>`
                            : `
                            <div class="header-mobile-search header-search-trigger hide-on-tablet
                                hide-on-desktop close-search" role="button" tabindex="1"
                                data-open-label="${window.Resources.OPEN_SEARCH_BAR}"
                                data-close-label="${window.Resources.CLOSE_SEARCH_BAR}"
                                aria-label="${window.Resources.OPEN_SEARCH_BAR}">
                                <i class="icon icon-icon-menu-close" aria-hidden="true" tabindex="1"></i>
                            </div>
                            `
                    }
                </div>
                <div class="product-suggestions-list">
                    <ul class="product-suggestions">
                        ${productsToDisplay.map(product => productSuggestion(product)).join('')}
                    </ul>
                </div>
                ${
                    products.length > MAX_SUGGESTIONS
                        ? `
                        <div class="show-more-ctr">
                            <a
                                class="show-more-link"
                                href="${searchURL}"
                                aria-label="${window.Resources.SHOW_MORE}"
                            >
                                ${window.Resources.SHOW_MORE}
                            </a>
                        </div>
                        `
                        : ''
                }
            </div>
        </div>
    `;
};
